// extracted by mini-css-extract-plugin
export var active = "_mr-2";
export var recordingDot = "_mr-1";
export var recordingIndicator = "_mr-0";